import React from "react";
import styled from "styled-components";

import { UnresetStyles } from "@examspark/common-ui/server";

type UnitContentProps = {
  content: string | null | undefined;
};

/**
 * Produces pretty typographics consistently across Bonfire.
 */
const PrintUnitContent = ({ content }: UnitContentProps) => {
  return (
    <PrintUnitContentWrapper>
      <UnresetStyles dangerouslySetInnerHTML={{ __html: content ?? "" }} />
    </PrintUnitContentWrapper>
  );
};

const BaseContentWrapper = styled.div`
  color: #222;
  line-height: 1.6em;
  font-size: 1.3rem;

  & > div > p:first-child {
    margin-top: 0;
  }
  & > div > p:last-child {
    margin-bottom: 0;
  }

  /* overflow: hidden; */

  & img {
    max-width: 100%;
  }

  // ensure long url's don't break the layout
  word-break: break-word;

  figure {
    margin: 0;
    padding: 0;
  }

  blockquote {
    padding: 1rem;
    border: solid 2px #000;
    margin: 1rem 0;
  }
`;

const PrintUnitContentWrapper = styled(BaseContentWrapper)``;
PrintUnitContent.Wrapper = PrintUnitContentWrapper;

export default PrintUnitContent;

// OLD STUFF HERE
// import { UnresetStyles } from "@examspark/common-ui/server";

// // @TODO: Import far more stuff from the original UnitContent
// const PrintUnitContent = ({
//   content,
// }: {
//   content: string | null | undefined;
// }) => {
//   return <UnresetStyles dangerouslySetInnerHTML={{ __html: content ?? "" }} />;
// };

// export default PrintUnitContent;
